/**
 * @fileOverview Cross
 */

export var Cell = function Cell(_props) {
  return null;
};
Cell.displayName = 'Cell';


//////////////////
// WEBPACK FOOTER
// ./node_modules/recharts/es6/component/Cell.js
// module id = 283
// module chunks = 0